export default "__VITE_ASSET__CmVPXe0a__"